import { useState } from "react";
import api from "../../../utils/axios";
import RichTextEditor from "./RichTextEditor";

function SectionEditor({ section, refresh, onPreviewChange  }) {
  const [settings, setSettings] = useState(section.settings_json || {});



  const saveSection = async () => {
    await api.put(`/sections/${section.id}`, {
      section_type: section.section_type,
      section_name: section.section_name,
      zone: section.zone,
      sort_order: section.sort_order,
      is_visible: section.is_visible,
      settings_json: settings
    });

    refresh();
  };

  const getDefaultItemPayload = () => {
    switch (section.section_type) {
      case "accordion":
        return {
          item_type: "accordion_item",
          content_json: {
            title: "New accordion title",
            body: "<p>New accordion body</p>",
            is_open_default: false
          }
        };

        case "list":
          return {
            item_type: "list_item",
            content_json: {
              text: "New list item",
              icon: "",
              link: ""
            }
          };

          case "cards":
            return {
              item_type: "card_item",
              content_json: {
                title: "New card",
                text: "Card text",
                button_text: "",
                button_url: ""
              }
            };

            case "downloads":
              return {
                item_type: "download_item",
                content_json: {
                  label: "New download",
                  description: "",
                  file_id: null
                }
              };

              case "gallery":
                return {
                  item_type: "gallery_item",
                  content_json: {
                    image_id: null,
                    caption: ""
                  }
                };

                case "news_ticker":
                  return {
                    item_type: "ticker_item",
                    content_json: {
                      text: "New update",
                      link: "",
                      label: "",
                      date: ""
                    }
                  };

                  default:
                    return null;
    }
  };

  const addItem = async () => {
    const payload = getDefaultItemPayload();

    if (!payload) {
      alert("This section type does not support items.");
      return;
    }

    await api.post(`/sections/${section.id}/items`, {
      ...payload,
      sort_order: (section.items?.length || 0) + 1,
      is_visible: true
    });

    refresh();
  };

  const deleteItem = async (itemId) => {
    if (!window.confirm("Delete this item?")) return;

    await api.delete(`/items/${itemId}`);
    refresh();
  };

  const updateSettings = (nextSettings) => {
    setSettings(nextSettings);

    onPreviewChange?.({
      ...section,
      settings_json: nextSettings
    });
  };

  return (
      <div style={{ marginTop: "15px" }}>
        <h5>Edit Section Content</h5>

        <label>Section title
          <input
              align={"left"}
              name={"title"}
              value={settings.title || ""}
              onChange={(e) =>
                  setSettings({ ...settings, title: e.target.value })
              }
              style={{ width: "100%", marginBottom: "10px" }}
          />
        </label>

        {section.section_type === "rich_text" && (
            <>
              <label>Rich text body
                <RichTextEditor
                    align={"left"}
                    value={settings.body || ""}
                    onChange={(html) =>
                        updateSettings({ ...settings, body: html })
                }
                />
              </label>
            </>
        )}

        <button className={"button"} onClick={saveSection}>
          Save Section
        </button>

        <hr />

        <h5>Section Items</h5>

        <button className={"button"} onClick={addItem}>
          + Add Item
        </button>

        {(section.items || []).length === 0 && (
            <p>No items in this section.</p>
        )}

        <ul style={{ marginTop: "10px" }}>
          {(section.items || []).map((item) => {
            const content = item.content_json || {};

            return (
                <li align={"left"} key={item.id} style={{ marginBottom: "10px" }}>
                  <strong>
                    {content.title ||
                        content.text ||
                        content.label ||
                        content.caption ||
                        item.item_type}
                  </strong>

                  <button
                      className={"button"}
                      onClick={() => deleteItem(item.id)}
                      style={{ marginLeft: "10px" }}
                  >
                    Delete Item
                  </button>
                </li>
            );
          })}
        </ul>
      </div>
  );
}

export default SectionEditor;